// extracted by mini-css-extract-plugin
export default {"flex__wrapper":"rocket_flex__wrapper__8iHLY"};